module.exports = __webpack_public_path__ + "static/MTG_Search-548d3eacde1171f61ecaa38514c39dad.png";